<div
  #idnoBlock
  class="p-field"
  [ngClass]="idnoStyleClass"
  [style.visibility]="isReadOnly ? 'hidden' : 'visible'"
  *ngIf="isShowIdentityNo"
>
  <div class="p-field-label">
    <label for="">
      <span class="p-text-red" *ngIf="isInputDataRequired">*</span>
      {{ identityNoText | translate }}
    </label>
  </div>
  <input pInputText [formControl]="identityNoControl" />
</div>
<div
  #customerNameBlock
  class="p-field"
  [ngClass]="customerNameStyleClass"
  [style.visibility]="isReadOnly ? 'hidden' : 'visible'"
>
  <div class="p-field-label">
    <label for="">
      <span class="p-text-red" *ngIf="isInputDataRequired">*</span>
      {{ customerNameText | translate }}
    </label>
  </div>
  <sigv-form-control-widget [bindingFormControl]="customerNameControl">
    <span class="p-input-icon-right">
      <input
        pInputText
        [formControl]="customerNameControl"
        placeholder=" {{ 'Please Enter' | translate }}"
      />
      <i class="pi pi-find cfc-clickable" (click)="onSearchIconClcik()"></i>
    </span>
  </sigv-form-control-widget>
</div>
<ng-content></ng-content>

<!-- 客戶名稱模糊查詢視窗 begin -->
<sigv-content-dialog
  *ngIf="showQueryDialog"
  [(visible)]="showQueryDialog"
  header=" "
  dialogSize="medium"
  [showCancel]="false"
  [showConfirm]="false"
  (cancel)="onDialogCancel()"
>
  <sigv-query-form-container
    [(collapse)]="collapse"
    [autoCollapse]="false"
    (cancel)="onQueryFormClear()"
    (search)="onQueryFormSearch()"
  >
    <ng-template pTemplate="conditions">
      <div class="p-field-wrapper">
        <div class="p-grid">
          <div class="p-field p-col-5-5">
            <div class="p-field-label">{{ 'Customer Name' | translate }}</div>
            <input pInputText [(ngModel)]="searchCustomerName" />
          </div>
        </div>
      </div>
    </ng-template>
  </sigv-query-form-container>
  <sigv-data-table
    [columns]="columns"
    [value]="rows"
    [reorderableColumns]="false"
    [paginator]="true"
    [loading]="tableLoading"
    [scrollable]="true"
    scrollHeight="500px"
    [forceCloseInformation]="true"
  >
    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr>
        <td *ngFor="let column of columns">
          <ng-container [ngSwitch]="column.field">
            <ng-container *ngSwitchCase="'identityNo'">
              <a sigvVisitedLink class="link" (click)="onIDNoLinkClick(row)">{{
                row.identityNo | replaceNullWith : '-'
              }}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'customerName'">
              <div class="p-text-left">
                {{ row.customerName | replaceNullWith : '-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'identificationTypeId'">
              {{
                row.identificationTypeId
                  | optionsMapping : identificationTypeOptions
                  | replaceNullWith : '-'
              }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ row[column.field] | replaceNullWith : '-' }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </sigv-data-table>
</sigv-content-dialog>
<!-- 客戶名稱模糊查詢視窗 end -->
